import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import {
  Grid,
  Paper,
  Snackbar,
  Typography,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import {
  getReviewById,
  selectReview,
  selectHasGuestAccess,
} from '../store/widgetSlice';

import ReviewCard from '../components/common/ReviewCard';
import WriteReviewDisputeForm from '../components/forms/WriteReviewDisputeForm';
import GuestAccessForm from '../components/forms/GuestAccessForm';
import {
  selectMessage,
  selectSeverity,
  clearMessage,
} from '../store/authSlice';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      padding: [theme.spacing(2)],
    },
    maxWidth: 700,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  content: {
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));

export default function Widget() {
  const classes = useStyles();
  const { reviewId } = useParams();
  const dispatch = useDispatch();
  const message = useSelector(selectMessage);
  const severity = useSelector(selectSeverity);
  const review = useSelector(selectReview);
  const hasGuestAccess = useSelector(selectHasGuestAccess);

  const handleClose = () => {
    dispatch(clearMessage());
  };

  useEffect(() => {
    if (reviewId && hasGuestAccess) {
      dispatch(getReviewById({ reviewId }));
    }
  }, [dispatch, reviewId, hasGuestAccess]);

  return (
    <Paper className={classes.root} elevation={1}>
      <Grid container className={classes.content}>
        <Grid item xs={12}>
          { (hasGuestAccess && review)
            ? (
              <>
                <Typography align="left" component="h1" variant="h5">Current Review</Typography>
                <Typography align="left" component="span" variant="body2" mt={2}>
                  Hover over or touch tags to see more detailed information.
                </Typography>
                <ReviewCard review={review} />
                <WriteReviewDisputeForm />
              </>
            )
            : <GuestAccessForm reviewId={reviewId} /> }
        </Grid>
      </Grid>
      <Snackbar open={!!message} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={severity}>{message}</Alert>
      </Snackbar>
    </Paper>
  );
}
